import { render } from "./SalesRecords.vue?vue&type=template&id=57d6b895&scoped=true"
import script from "./SalesRecords.vue?vue&type=script&lang=js"
export * from "./SalesRecords.vue?vue&type=script&lang=js"

import "./SalesRecords.vue?vue&type=style&index=0&id=57d6b895&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57d6b895"]])

export default __exports__